// We generally prefer using moment objects instead of Javascript date objects
//  to be consistent. But these functions are here if you really need them.

export const isJavascriptDate = (obj: unknown): obj is Date =>
    Object.prototype.toString.call(obj) === '[object Date]';

export const areJavascriptDatesEqual = (date1: Date, date2: Date): boolean =>
    date1.getTime() === date2.getTime();
